"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

//     NoFlo - Flow-Based Programming for JavaScript
//     (c) 2014-2017 Flowhub UG
//     NoFlo may be freely distributed under the MIT license
var BasePort = require('./BasePort');

var IP = require('./IP'); // ## NoFlo outport
//
// Outport Port (outport) implementation for NoFlo components.
// These ports are the way a component sends Information Packets.


module.exports = /*#__PURE__*/function (_BasePort) {
  _inherits(OutPort, _BasePort);

  var _super = _createSuper(OutPort);

  function OutPort() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, OutPort);

    var opts = options;

    if (opts.scoped == null) {
      opts.scoped = true;
    }

    _this = _super.call(this, opts);
    _this.cache = {};
    return _this;
  }

  _createClass(OutPort, [{
    key: "attach",
    value: function attach(socket) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      _get(_getPrototypeOf(OutPort.prototype), "attach", this).call(this, socket, index);

      if (this.isCaching() && this.cache[index] != null) {
        this.send(this.cache[index], index);
      }
    }
  }, {
    key: "connect",
    value: function connect() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sockets = this.getSockets(index);
      this.checkRequired(sockets);
      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        socket.connect();
      });
    }
  }, {
    key: "beginGroup",
    value: function beginGroup(group) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var sockets = this.getSockets(index);
      this.checkRequired(sockets);
      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        socket.beginGroup(group);
      });
    }
  }, {
    key: "send",
    value: function send(data) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var sockets = this.getSockets(index);
      this.checkRequired(sockets);

      if (this.isCaching() && data !== this.cache[index]) {
        this.cache[index] = data;
      }

      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        socket.send(data);
      });
    }
  }, {
    key: "endGroup",
    value: function endGroup() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sockets = this.getSockets(index);
      this.checkRequired(sockets);
      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        socket.endGroup();
      });
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var sockets = this.getSockets(index);
      this.checkRequired(sockets);
      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        socket.disconnect();
      });
    }
  }, {
    key: "sendIP",
    value: function sendIP(type, data, options, index) {
      var autoConnect = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var ip;
      var idx = index;

      if (IP.isIP(type)) {
        ip = type;
        idx = ip.index;
      } else {
        ip = new IP(type, data, options);
      }

      var sockets = this.getSockets(idx);
      this.checkRequired(sockets);

      if (ip.datatype === 'all') {
        // Stamp non-specific IP objects with port datatype
        ip.datatype = this.getDataType();
      }

      if (this.getSchema() && !ip.schema) {
        // Stamp non-specific IP objects with port schema
        ip.schema = this.getSchema();
      }

      var cachedData = this.cache[idx] != null ? this.cache[idx].data : undefined;

      if (this.isCaching() && data !== cachedData) {
        this.cache[idx] = ip;
      }

      var pristine = true;
      sockets.forEach(function (socket) {
        if (!socket) {
          return;
        }

        if (pristine) {
          socket.post(ip, autoConnect);
          pristine = false;
        } else {
          if (ip.clonable) {
            ip = ip.clone();
          }

          socket.post(ip, autoConnect);
        }
      });
      return this;
    }
  }, {
    key: "openBracket",
    value: function openBracket() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.sendIP('openBracket', data, options, index);
    }
  }, {
    key: "data",
    value: function data(_data) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.sendIP('data', _data, options, index);
    }
  }, {
    key: "closeBracket",
    value: function closeBracket() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      return this.sendIP('closeBracket', data, options, index);
    }
  }, {
    key: "checkRequired",
    value: function checkRequired(sockets) {
      if (sockets.length === 0 && this.isRequired()) {
        throw new Error("".concat(this.getId(), ": No connections available"));
      }
    }
  }, {
    key: "getSockets",
    value: function getSockets(index) {
      // Addressable sockets affect only one connection at time
      if (this.isAddressable()) {
        if (index === null) {
          throw new Error("".concat(this.getId(), " Socket ID required"));
        }

        if (!this.sockets[index]) {
          return [];
        }

        return [this.sockets[index]];
      } // Regular sockets affect all outbound connections


      return this.sockets;
    }
  }, {
    key: "isCaching",
    value: function isCaching() {
      if (this.options.caching) {
        return true;
      }

      return false;
    }
  }]);

  return OutPort;
}(BasePort);